"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var lodash_1 = require("lodash");
var api_request_1 = require("../../api_request");
var curation_actions_1 = require("../actions/curation_actions");
var classNames = require("classnames");
var TileCurationView = /** @class */ (function (_super) {
    tslib_1.__extends(TileCurationView, _super);
    function TileCurationView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            bumped: lodash_1.get(_this.props, 'admin.bumped'),
            featuredInSet: lodash_1.get(_this.props, 'admin.featured_in_set') || false,
            bumpError: false,
            featureInSetError: false,
        };
        _this.bumpListing = _this.bumpListing.bind(_this);
        _this.toggleFeaturedInSet = _this.toggleFeaturedInSet.bind(_this);
        _this.startCuration = _this.startCuration.bind(_this);
        return _this;
    }
    Object.defineProperty(TileCurationView.prototype, "href", {
        get: function () {
            return "/admin/curated_sets/for_product/" + this.props.listingId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TileCurationView.prototype, "bumpHref", {
        get: function () {
            return "/admin/bumps/" + this.props.listingId + "/bump";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TileCurationView.prototype, "featureInSetHref", {
        get: function () {
            var curatedSetId = this.props.admin.curated_set_id;
            var listingId = this.props.listingId;
            return "/admin/curated_sets/" + curatedSetId + "/feature?product_id=" + listingId;
        },
        enumerable: true,
        configurable: true
    });
    TileCurationView.prototype.bumpListing = function (e) {
        var _this = this;
        e.preventDefault();
        e.stopPropagation();
        var req = api_request_1.V3.post(this.bumpHref).then(function () {
            _this.setState({ bumped: true });
        });
        req.fail(function () {
            _this.setState({ bumpError: true });
        });
    };
    TileCurationView.prototype.toggleFeaturedInSet = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.state.featuredInSet) {
            this.unfeatureInSet();
        }
        else {
            this.featureInSet();
        }
    };
    TileCurationView.prototype.featureInSet = function () {
        var _this = this;
        api_request_1.V3.post(this.featureInSetHref).done(function () {
            _this.setState({ featuredInSet: true });
        }).fail(function () {
            _this.setState({ featureInSetError: true });
        });
    };
    TileCurationView.prototype.unfeatureInSet = function () {
        var _this = this;
        api_request_1.V3.destroy(this.featureInSetHref).done(function () {
            _this.setState({ featuredInSet: false });
        }).fail(function () {
            _this.setState({ featureInSetError: true });
        });
    };
    TileCurationView.prototype.startCuration = function (e) {
        e.preventDefault();
        e.stopPropagation();
        curation_actions_1.default.fetchIndex({
            product_id: this.props.listingId,
        });
    };
    TileCurationView.prototype.renderBumpButton = function () {
        if (this.state.bumpError) {
            return I18n.t('discovery.curation.error');
        }
        if (this.state.bumped) {
            return (React.createElement("button", { className: "button button--mini", "data-disabled": true }, I18n.t('discovery.curation.bumped')));
        }
        return (React.createElement("button", { onClick: this.bumpListing, className: "button button--mini mb-half" }, I18n.t('discovery.curation.bumpButton')));
    };
    TileCurationView.prototype.renderFeaturedSetControls = function () {
        if (!lodash_1.get(this.props, 'admin.curated_set_id')) {
            return null;
        }
        if (this.state.featureInSetError) {
            return (React.createElement("div", { className: "color-red" }, I18n.t('discovery.curation.error')));
        }
        var text = this.state.featuredInSet ?
            I18n.t('discovery.curation.featuredInSet') : I18n.t('discovery.curation.feature');
        return (React.createElement("button", { className: "button button--mini mb-half", onClick: this.toggleFeaturedInSet, "data-featured-button": true },
            React.createElement("span", { className: classNames({ 'icon-l-check': this.state.featuredInSet }) }, text)));
    };
    TileCurationView.prototype.render = function () {
        return (React.createElement("div", { className: "bdt-1 bd--offwhite plr-half pt-half" },
            React.createElement("div", { className: "d-flex fx-justify-between fx-wrap width-100" },
                React.createElement("button", { className: "button button--mini mb-half", onClick: this.startCuration }, I18n.t('discovery.curation.curateButton')),
                this.renderBumpButton(),
                this.renderFeaturedSetControls())));
    };
    return TileCurationView;
}(React.Component));
exports.default = TileCurationView;
//# sourceMappingURL=tile_curation_view.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/curation/tile_curation_view.js
// module id = OtjC
// module chunks = 20 21